import { render, staticRenderFns } from "./SwPage.vue?vue&type=template&id=5bcc0cad&scoped=true"
import script from "./SwPage.vue?vue&type=script&lang=js"
export * from "./SwPage.vue?vue&type=script&lang=js"
import style0 from "./SwPage.vue?vue&type=style&index=0&id=5bcc0cad&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc0cad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bcc0cad')) {
      api.createRecord('5bcc0cad', component.options)
    } else {
      api.reload('5bcc0cad', component.options)
    }
    module.hot.accept("./SwPage.vue?vue&type=template&id=5bcc0cad&scoped=true", function () {
      api.rerender('5bcc0cad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/SwPage.vue"
export default component.exports